module.exports = __webpack_public_path__ + "apple-touch-icon.17ea24e5.png";